import { MenuImagesNames } from './assets/types';
import type { IIconProps } from '../DataDisplay/Icon/Icon';

export type Link = {
  href: string;
  title: string;
  trackingId?: string;
  locale?: string;
};

export type CardWIcon = Link & {
  icon: IIconProps['icon'];
  description?: string;
};

export type CardWImage = Link & {
  image: MenuImagesNames;
  imagePos?: 'top' | 'bottom';
  description?: string;
};

export type Tabs = {
  id: string;
  type: 'tabs';
  title: string;
  children: Array<Tab>;
};

export type Tab = {
  // TODO: this `id` appears to only be used for internal purposes and would be
  //   better to eliminate/randomize with something like `crypto.randomUUID()`.
  id: string;
  type: 'list';
  title: string;
  children: Array<(CardWIcon & { isOverview?: boolean }) | CardWImage>;
};

export type Columns = {
  id: string;
  title: string;
} & (
  | {
      type: 'columns';
      children: [
        {
          title: string;
          children?: CardWIcon[];
        },
        {
          title: string;
          children?: Link[];
        },
      ];
    }
  | {
      type: 'columnsWithCardWIcons';
      children: [
        {
          title: string;
          children?: CardWIcon[];
        },
        {
          title: string;
          children?: CardWIcon[];
        },
      ];
    }
);

export type List = {
  id: string;
  type: 'list';
  title: string;
  columns?: number;
  children?: Array<CardWIcon>;
};

export type NavDataItems = Array<
  (Link & { id: string }) | Tabs | Columns | List
>;

export type NavData = {
  items: NavDataItems;
  ctaTrackingIds: { getAPIkeys: string };
};

export type SubMenuData = Tabs | Columns | List;

export const isLink = (obj: any): obj is Link => {
  return typeof obj === 'object' && obj !== null && !('children' in obj);
};

export const isCardWIcon = (obj: any): obj is CardWIcon => {
  return typeof obj === 'object' && obj !== null && 'icon' in obj;
};

export const isCardWImage = (obj: any): obj is CardWImage => {
  return typeof obj === 'object' && obj !== null && 'image' in obj;
};
